import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

export const configureDayjs = preferredLanguageCode => {
    dayjs.locale(preferredLanguageCode);
    dayjs.extend(isBetween);
    dayjs.extend(isSameOrAfter);
};
